import { STOCK_UNITS } from '../constants/Stock';
import { validateVatClassification, toVatPayload } from './vatClassification';
import { resolvedContentQuantity } from './stockQuantityUtils';

export const validateProductForm = (form, languages = ['en']) => {
  const errors = {};
  const hasAllNames = (languages || []).every((language) => form?.name?.[language]?.trim());

  if (!hasAllNames) {
    errors.name = 'productsManagement.validation.nameRequired';
  }

  if (form?.isRetail !== false) {
    const price = Number(form?.price);
    if (!Number.isFinite(price) || price <= 0) {
      errors.price = 'productsManagement.validation.priceRequired';
    }
  }

  const contentQuantity = resolvedContentQuantity(form?.stockUnit, form?.contentQuantity);
  if (!Number.isFinite(contentQuantity) || contentQuantity <= 0) {
    errors.contentQuantity = 'productsManagement.validation.contentRequired';
  }

  if (form?.stockUnit && !STOCK_UNITS.includes(form.stockUnit)) {
    errors.stockUnit = 'productsManagement.validation.unitRequired';
  }

  if (form?.lowStockPackages !== '' && form?.lowStockPackages != null) {
    const threshold = Number(form.lowStockPackages);
    if (!Number.isFinite(threshold) || threshold < 0) {
      errors.lowStockThreshold = 'productsManagement.validation.lowStockInvalid';
    }
  }

  return {
    ...errors,
    ...validateVatClassification(form),
  };
};

export const buildProductSavePayload = (form, languages = ['en']) => {
  const isRetail = form?.isRetail !== false;
  const contentQuantity = resolvedContentQuantity(form?.stockUnit, form?.contentQuantity);
  const lowStockPackages = form?.lowStockPackages === '' || form?.lowStockPackages == null
    ? null
    : Number(form.lowStockPackages);
  const localized = (values) => Object.fromEntries(
    (languages || []).map((language) => [language, values?.[language] || '']),
  );

  return {
    id: form?.id ?? null,
    name: localized(form?.name),
    description: localized(form?.description),
    price: isRetail ? Number(form?.price) : null,
    salePrice: isRetail ? Number(form?.price) : null,
    isRetail,
    stockUnit: form?.stockUnit || 'Unit',
    contentQuantity,
    lowStockThreshold: lowStockPackages == null ? null : lowStockPackages * contentQuantity,
    disabled: Boolean(form?.disabled),
    ...toVatPayload(form),
    imageFile: form?.imageFile || null,
    removeImage: Boolean(form?.removeImage),
  };
};
